export const LOGIN_USER = "LOGIN_USER";
export const INITIALIZE_STORE = "INITIALIZE_STORE";
export const LOGOUT_USER = "LOGOUT_USER";
export const SAVE_SEARCH_RESULTS = "SAVE_SEARCH_RESULTS";
export const REFRESH_ACCESS_TOKEN = "REFRESH_ACCESS_TOKEN";
export const SHOW_PERMISSION_ERROR = "SHOW_PERMISSION_ERROR";
export const SET_UNREAD_MESSAGES_COUNT = "SET_UNREAD_MESSAGES_COUNT";